// extracted by mini-css-extract-plugin
export default {"shellTitle":"TitleAndDescription_shellTitle__n4Epl","titles":"TitleAndDescription_titles__t8ozz","iconInfo":"TitleAndDescription_iconInfo__eCx4u"};